<template>
  <div class="main">
    <FullCalendar
      :options="calendarOptions"
    />
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from "@fullcalendar/daygrid";

import "@fullcalendar/common/main.css";
import "@fullcalendar/daygrid/main.css";

import sx from '../utils/core.js'

export default {
  components: {
    FullCalendar
  },
  created () {
    this.$store.state.title = 'カレンダ'
    this.calendarOptions.events = [];
  },
  mounted() {
    sx.showWaiting()
    const that = this

    var params = {
      corpid: 40,
      bucketid: '17',
      token: localStorage.getItem('token') || 'token'
    }
    var url = that.$store.state.baseurl + '/app/cmshelper/fetchCalendar';
    sx.request(
      url,
      params,
      function(result) {
        if (result.status === 'ok') {
          that.events = [];
          result.data.rows.forEach(function(item, index) {
            var line = {
              title: item.name,
              date: item.workday
            };
            that.calendarOptions.events.push(line);
          });
          sx.hideWaiting()
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
        }
      },
      function() {
        sx.login(
          url,
          params,
          function(result) {
            if (result.status === 'ok') {
              that.events = [];
              result.data.rows.forEach(function(item, index) {
                var line = {
                  title: item.name,
                  date: item.workday
                };
                that.calendarOptions.events.push(line);
              });
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
            }
          }
        )
      }
    )
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin],
        initialView: 'dayGridMonth',
        weekends: true, // initial value
        locale: 'ja',
        aspectRatio: 0.9,
        events: []
      }
    }
  }
}
</script>
<style scoped>
.main{
  padding:8px;
}
</style>
